var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.emplist = {
	init:function() {
		$('.wrap','#empList').slimScroll({
			height:'100%',
			color:"#000",
			alwaysVisible:true,
			wheelStep : 10,
			touchScrollStep : 50
		});
	}
};

site.isotope = {
	init: function () {
		// Combine employees from various branches
		var emps = $('.employee').clone();
		$('#empList .employees').remove();
		$('<div class="employees"></div>').appendTo($('#empList .wrap'));

		emps.appendTo($('#empList .employees'));

		// quick search regex
		var qsRegex;
		var buttonFilter;

		var $grid = $('#empList .employees').isotope({
			itemSelector: '.employee',
			layoutMode: 'fitRows',
			filter: function() {
				var $this = $(this);
				var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
				var buttonResult = buttonFilter ? $this.is( buttonFilter ) : true;
				return searchResult && buttonResult;
			},
			getSortData: {
				name: '[data-name]'
			},
			sortBy: 'name'
		});

		$group = $('.employee-filter-button-group');
		$group.on( 'click', 'a', function() {
			buttonFilter = $( this ).attr('data-filter');
			$grid.isotope();
		});

		var $quicksearch = $('.quicksearch').keyup( debounce( function() {
			qsRegex = new RegExp( $quicksearch.val(), 'gi' );
			$grid.isotope();
		}) );

		$group.each( function( i, buttonGroup ) {
			var $buttonGroup = $( buttonGroup );
			$buttonGroup.on( 'click', 'a', function() {
				$buttonGroup.find('.active').removeClass('active');
				$( this ).addClass('active');
			});
		});


		function debounce( fn, threshold ) {
			var timeout;
			return function debounced() {
				if ( timeout ) {
					clearTimeout( timeout );
				}
				function delayed() {
					fn();
					timeout = null;
				}
				setTimeout( delayed, threshold || 100 );
			};
		}
	}
};

site.employees = {
	init: function () {
		$('.empToggle, .employees__close, .ele-starfsfolk > a, .ele-employees > a, .ele-mitarbeiter > a').on('click', function(e) {
			e.preventDefault();

			// Lazy load images
			// https://www.sitepoint.com/five-techniques-lazy-load-images-website-performance
			[].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
				img.setAttribute('src', img.getAttribute('data-src'));
				img.onload = function () {
					img.removeAttribute('data-src');
				};
			});

			$('body').toggleClass('employees-open');

			$('body.employees-open').on('click touchstart', function (e) {
				var $closest = $(e.target).closest('li');
				if (!$closest.hasClass('ele-starfsfolk') &&
					!$closest.hasClass('ele-employees') &&
					!$closest.hasClass('ele-mitarbeiter')
					&& !$(e.target).hasClass('empToggle')
					&& !$(e.target).parent().hasClass('empToggle')
					&& !$(e.target).parents('#empList').length) {
					$('body').removeClass('employees-open');
				}
			});
		});
		
		// $('.ele-starfsfolk').on('click', function(e) {
		// 	e.preventDefault();
		// 	$('body').toggleClass('employees-open');
		// });
	}
};


site.frontpage = {
	init: function() {

	}
};

site.projectsMixitup = {
	init: function() {
		var targetSelector = '.project';

		/**
		 * Reads a hash from the URL (if present), and converts it into a class
		 * selector string. E.g "#green" -> ".green". Otherwise, defaults
		 * to the targetSelector, equivalent to "all"
		 *
		 * @return {string}
		 */
		function getSelectorFromHash() {
			var hash = window.location.hash.replace(/^#/g, '');

			var selector = hash ? '.' + hash : targetSelector;

			return selector;
		}

		/**
		 * Updates the URL whenever the current filter changes.
		 *
		 * @param   {mixitup.State} state
		 * @return  {void}
		 */
		function setHash(state) {
			var selector = state.activeFilter.selector;
			var newHash = '#' + selector.replace(/^./g, '');

			if (selector === targetSelector && window.location.hash) {
				// Equivalent to filter "all", remove the hash

				history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
			} else if (newHash !== window.location.hash && selector !== targetSelector) {
				// Change the hash

				history.pushState(null, document.title, window.location.pathname + newHash); // or history.replaceState()
			}
		}

		// Instantiate and configure the mixer
		var mixer = mixitup('.projectsContainer', {
			selectors: {
				target: targetSelector
			},
			animation: {
				duration: 400
			},
			load: {
				filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
			},
			callbacks: {
				onMixEnd: setHash // Call the setHash() method at the end of each operation
			}
		});

		window.onhashchange = function() {
			var selector = getSelectorFromHash();
			if (selector === mixer.getState().activeFilter.selector) return; // no change

			mixer.filter(selector);
		};
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.isotope.init();
	site.emplist.init();
	site.employees.init();

	if ($('.projectsContainer').length) {
		site.projectsMixitup.init();
	}

	$frontOwlSettings = {
		nav: true,
		navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
		responsive:{
			0:{
				items:2
			},
			375:{
				items:3
			}
		}
	};

	if ($('body').is(".frontpage") && $(window).width() < 768) {
		site.owl.init('.icons .items', $frontOwlSettings);
	}

	$(window).resize(function () {
		if ($(window).width() < 768) {
			site.owl.init('.icons .items', $frontOwlSettings);
		} else {
			$('.icons .items').trigger('destroy.owl.carousel');
		}
	});

	if ($('body').is(".project")) {
		site.owl.init('.owl-hero', {
			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
			autoplay: true,
			autoplayHoverPause: true,
			autoplayTimeout: 7000,
			dots: true,
			items: 1,
			loop:true,
			mouseDrag: true,
			nav: true,
			navText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
			touchDrag: true
		})
	}

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	$(window).scroll(function() {
		var scroll = $(window).scrollTop();
		var width = $(window).width();
		var $isFrontpage = $('.frontpage').length > 0;

		if (width < 768) {
			if (scroll >= 80) {
				$('body').addClass("has-scrolled");
			} else {
				$('body').removeClass("has-scrolled");
			}
		}

		if (width >= 768 && width <= 992) {
			if (scroll >= 80) {
				$('body').addClass("has-scrolled");
			} else {
				$('body').removeClass("has-scrolled");
			}
		}

		if (width > 992) {
			if ((scroll > 600 && $isFrontpage) || (scroll > 170 && !$isFrontpage)) {
				$('body').addClass("has-scrolled");
			}
			else {
				$('body').removeClass("has-scrolled");
			}
		}
	});
});